'use client'

import {
    CircleCheckIcon,
    InfoIcon,
    Loader2Icon,
    OctagonXIcon,
    TriangleAlertIcon,
} from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

import { cn } from '@/lib/utils'

const Toaster = ({ ...props }: ToasterProps) => {
    const { theme = 'system' } = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            className={cn(
                'toaster group',
                // Base styles
                '[&>div]:flex! [&>div]:items-center! [&>div]:gap-3!',
                '[&>div]:rounded-md! [&>div]:p-4! [&>div]:shadow-lg!',
                '[&>div]:transition-all! [&>div]:duration-300!',
                // Light mode
                '[&>div]:bg-white! [&>div]:text-slate-900!',
                '[&>div]:border! [&>div]:border-slate-200!',
                // Dark mode
                'dark:[&>div]:bg-slate-900! dark:[&>div]:text-slate-100!',
                'dark:[&>div]:border-slate-800!',
                // Success toast
                '[&>div[data-type="success"]]:bg-gradient-to-r! [&>div[data-type="success"]]:from-blue-500! [&>div[data-type="success"]]:to-blue-600!',
                '[&>div[data-type="success"]]:text-white!',
                'dark:[&>div[data-type="success"]]:from-blue-600! dark:[&>div[data-type="success"]]:to-blue-800!',
                // Error toast
                '[&>div[data-type="error"]]:bg-red-500! [&>div[data-type="error"]]:text-white!',
                'dark:[&>div[data-type="error"]]:bg-red-900!',
                // Warning toast
                '[&>div[data-type="warning"]]:bg-amber-500! [&>div[data-type="warning"]]:text-white!',
                'dark:[&>div[data-type="warning"]]:bg-amber-900!',
                // Info toast
                '[&>div[data-type="info"]]:bg-blue-50! [&>div[data-type="info"]]:text-blue-900!',
                'dark:[&>div[data-type="info"]]:bg-blue-900/20! dark:[&>div[data-type="info"]]:text-blue-100!',
                // Loading toast
                '[&>div[data-type="loading"]]:bg-slate-50!',
                'dark:[&>div[data-type="loading"]]:bg-slate-800!',
                // Icon styles
                '[&_svg]:size-5! [&_svg]:shrink-0!',
                '[&_svg]:transition-colors! [&_svg]:duration-300!'
            )}
            icons={{
                success: <CircleCheckIcon />,
                error: <OctagonXIcon />,
                warning: <TriangleAlertIcon />,
                info: <InfoIcon />,
                loading: <Loader2Icon className="animate-spin" />,
            }}
            {...props}
        />
    )
}

export { Toaster }
